import { useMutation } from '@tanstack/react-query';
import { AddWelfareImages, CreateWelfare, DeleteWelfare, DragAndDropWelfare, UpdateWelfare } from '../../../Api/welfare';

export const useMutateEditWelfare = () =>
  useMutation({
    mutationFn: (data) => UpdateWelfare(data),
  });

  export const useMutateDeleteWelfare = () =>
    useMutation({
      mutationFn: (data) => DeleteWelfare(data),
    });
  
  export const useMutateCreateWelfareImage = () =>
    useMutation({
      mutationFn: (data) => AddWelfareImages(data),
    });
  
    export const useMutateDragDropWelfare = () =>
      useMutation({
        mutationFn: (data) => DragAndDropWelfare(data),
      });

      export const useMutateCreateWelfare = () =>
        useMutation({
          mutationFn: (data) => CreateWelfare(data),
        });